import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import hrLocale from 'date-fns/locale/hr';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PropTypes from 'prop-types';
import { useLocalization } from '../contexts/localizationContext';
import constants from '../constants';

export default function DateLocalization({children}) {
  const localization = useLocalization();
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={localization.locale === constants.locales.hrHR ? hrLocale : undefined}
    >
      {children}
    </LocalizationProvider>
  );
}

DateLocalization.propTypes = {
  children: PropTypes.any
};